/** @format */

import { api } from "./client";

export interface TranscriptionSegment {
  start_time: number;
  end_time: number;
  text: string;
}

export interface MediaTranscription {
  status: "pending" | "in_progress" | "completed" | "failed";
  segments?: TranscriptionSegment[];
  full_text?: string;
}

export interface SOPMedia {
  id: string;
  /** `render` = standalone STEP CAD preview PNG from the API when the STEP blob is excluded from the list */
  type: "video" | "image" | "step_file" | "document" | "render";
  s3_key: string;
  url: string;
  file_type: string;
  name?: string;
  image_ref_id?: string; // UUID that works with /download_urls
  selected_for_regeneration_at?: string | null;
  transcription?: MediaTranscription;
  extracted?: {
    frames: Array<{
      id: string;
      s3_key: string;
      timestamp: number;
      frame_number: number;
      url: string;
      image_ref_id?: string; // UUID for each frame
    }>;
    renders: Array<{
      id: string;
      s3_key: string;
      url: string;
      image_ref_id?: string; // UUID for each render
      view_name: string;
      view_type: string;
      width: number;
      height: number;
    }>;
  };
}

export interface SOPMediaResponse {
  sop_id: string;
  original_media: SOPMedia[];
}

export const getSOPMedia = async (sopId: string): Promise<SOPMediaResponse> => {
  const response = await api.get(`/sop/${sopId}/media`);
  return response.data;
};

export const getMediaTranscription = async (
  sopId: string,
  mediaId: string
): Promise<MediaTranscription> => {
  const response = await api.get(
    `/sop/${sopId}/media/${mediaId}/transcription`
  );
  return response.data;
};
